module.exports = __webpack_public_path__ + "static/media/mdi_location_on.f3b252f7.svg";